/**
 * Shows the clickable hotspots (bubbles) on a container.
 *
 * @author Erik Jan Lam
 * @date Nov 28 2018
 */

var $ = require('jquery');
var imgLoaded = require('../utils/image').loaded;
var imgScale = require('../utils/image').getRenderedSize;
import {debounce} from '../components/custom-lodash';

var defaults = {
    rootSelector: '.teaser-with-marks',
    bubbleSelector: '.marks-items'
};

exports.init = function (settings) {
    var config = $.extend({}, defaults, settings || {});

    function drawBubbles(element) {
        // Get the size of the image div
        var rect = element.getBoundingClientRect();
        var img = element.querySelector('img');
        var imgData;
        var offset = {x: 0, y: 0};
        if (img) {
            imgData = imgScale(img);
            offset = {x: imgData.x, y: imgData.y};
        }
        var valueHEIGHT = imgData ? imgData.renderedHeight : rect.height;
        var valueWIDTH = imgData ? imgData.renderedWidth : rect.width;
        var $container = $(element);

        // position all the bubbles.
        $container.find(config.bubbleSelector).each(function () {
            // Get the values present in the ID
            var $element = $(this);
            var idValues = $element.attr('id');

            // Get the % Values
            var valueX = idValues.substring(9, 12);
            var valueY = idValues.substring(13, 16);

            // size of the circle (make the value count in the center, not in the edge)
            var valueCircle = this.offsetWidth / 2;

            // Transform the % relative value in exact pixel value
            var topX = Math.round((valueX * valueWIDTH) / 100 - valueCircle + offset.x);
            var bottomY = Math.round((valueY * valueHEIGHT) / 100 - valueCircle + offset.y);

            // Create the Top and left values in inline CSS
            $element.css({bottom: bottomY, left: topX});
        });

        // show all the bubbles.
        $container.addClass('hotspots-visible');
    }

    function drawAllBubbles(selector) {
        // initialize all the elements with hotspots.
        $(selector).each(function () {
            var container = this;
            drawBubbles(container);

            // Redraw bubbles when images inside bubble container are loaded (container size can change).
            $(container)
                .find('img')
                .each(function (i, img) {
                    imgLoaded(img, function () {
                        drawBubbles(container);
                    });
                });
        });
    }

    drawAllBubbles(config.rootSelector);
    var resizeHandler = debounce(function () {
        drawAllBubbles(config.rootSelector);
    }, 50);
    window.addEventListener('resize', resizeHandler);
};
